export default class AnnotationModel extends Backbone.Model {

    get defaults() {
        return {
            searchContent: '',
            isVisible: true,
            chapter_id: 0,
            section_id: 0,
            activity_id: 0,
            task_group_id: 0,
            task_group_sequence: 0,
        }
    }

    get path() {
        const path = this.pick(
            'chapter_id',
            'section_id',
            'activity_id',
        )
        if (path.activity_id) {
            return Backbone.Collection.activities.get(path.activity_id)
        }
        if (path.section_id) {
            return Backbone.Collection.sections.get(path.section_id)
        }
        if (path.chapter_id) {
            return Backbone.Collection.chapters.get(path.chapter_id)
        }
        return this.getGroupModel()
    }

    set path(model) {
        if (model.constructor.type === 'activity') {
            this.set({
                activity_id: model.id,
                section_id: model.getSectionModel().id,
                chapter_id: model.getChapterModel().id,
            })
        } else if (model.constructor.type === 'section') {
            this.set({
                section_id: model.id,
                chapter_id: model.getChapterModel().id,
                activity_id: 0,
            })
        } else if (model.constructor.type === 'chapter') {
            this.set({
                chapter_id: model.id,
                section_id: 0,
                activity_id: 0,
            })
        }
    }

    preinitialize() {
        this.constructor.type = 'annotation'
    }

    initialize() {
        this.on('changeFilter', this.onChangeFilter);
    }

    url() {
        if (!this.id) {
            return '/annotations/save_new_annotation.json';
        }
        return '/annotations/save_annotation/' + this.id + '.json'
    }

    // Will be called on trigger changeFilter
    onChangeFilter(state) {
        // Set the isVisible to the state of the filter checkbox
        this.set('isVisible', state);
    }

    getGroupModel() {
        return Backbone.Collection.groups.get(this.get('group_id'))
    }

    saveToGroup(callback) {
        this.getGroupModel().annotations.createAnnotation(this.toJSON(), callback)
    }

}
